import { ComponentProps } from "react";

import { ContentCard } from "./ContentCard";
import { HorizontalCard } from "./scaffolds/HorizontalCard";
import { VerticalHalfCard } from "./scaffolds/VerticalHalfCard";

export const CurationContentCard = ({
    device,
    ...props
}: Omit<ComponentProps<typeof ContentCard>, "type">) => {
    const map = {
        "web+tablet": <VerticalHalfCard {...props} />,
        app: <HorizontalCard {...props} />
    };

    return device ? (
        map[device]
    ) : (
        <>
            <VerticalHalfCard className="hidden md:flex" {...props} />
            <HorizontalCard className="flex md:hidden" {...props} />
        </>
    );
};
